'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {ListCtrl} from '../esfasi/listctrl.js';

import {communicationSubjectModel} from "../../models/communicationsubjectmodel.js";
import {CommunicationSubjectEditorCtrl} from './communicationsubjecteditorctrl.js';

export class CommunicationSubjectListCtrl extends ListCtrl
{
	$mdDialog;
	
	storageNames = {
		query: 'SubjectListCtrl'
	};
	
	appName;
	
	objectNumber;
	
	canWrite;
		
	query = {
		order: '',
		limit: 20,
		page: 1,
		filters: {
			query: {
				value: ''
			},
		}
	};
	defaultQuery = {
		order: '',
		limit: 20,
		page: 1,
		filters: {
			query: {
				value: ''
			},
		}
	};
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService, $mdDialog){
		super($scope, $http, $filter, $timeout, $locale, jsDataService);
		this.$mdDialog = $mdDialog;
		this.appName = jsDataService.get('cfgAppName');
		this.objectNumber = jsDataService.get('objectNumber');
		this.canWrite = jsDataService.get('canWrite', false);
	}
	
	setData(data){
		this.data = [];
		for(let ln of data){
			this.data.push(new communicationSubjectModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		if(row instanceof communicationSubjectModel){
			return row.getValue(col);
		}
		return row[col];
	}
	
	openSubjectDialog(ev, subject = null){
		if(!subject){
			const draftMessage = this.jsDataService.get('draftMessage');
			
			subject = new communicationSubjectModel({
				id: draftMessage?.id || '',
				subject: draftMessage?.subject || '',
				message: draftMessage?.message || '',
				attachment: draftMessage?.attachment || [],
				object_number: this.objectNumber,
				delete_url: draftMessage?.delete_url || '',
			});
		}
		
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'subject', CommunicationSubjectEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'communication/subject_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject,
			}
		}).then((results) => {
			this.saveSubject(results)
				.then((response) => {
					console.log(response);
					if(response.data.success) {
						this.publishSubject(response.data.data);
					}
				});
		}, (results) => {
			console.log(results);
		});
	}
	
	saveSubject(data){
		const draftMessage = this.jsDataService.get('draftMessage');
		const autosave = this.jsDataService.get('autosave');
		
		return this.$scope.basicHttpConfigProcess({
			url: autosave.url,
			method: 'POST',
			data: {
				id: data.id,
				subject: data.subject,
				message: data.message,
				attachment: data.attachment.map(({id, file_id}) => ({id, file_id})),
			}
		});
	}
	
	publishSubject(data){
		this.$scope.basicHttpConfigProcess({
			url: data.publish_url,
			method: 'POST',
		}).then((response) => {
			if(response.data.success){
				this.loadData();
				this.jsDataService.set('draftMessage', null);
			}
		}, () => {});
	}
}